import { render, staticRenderFns } from "./ShippingMethodsForOrderPopup.vue?vue&type=template&id=778f543e&scoped=true"
import script from "./ShippingMethodsForOrderPopup.vue?vue&type=script&lang=js"
export * from "./ShippingMethodsForOrderPopup.vue?vue&type=script&lang=js"
import style0 from "./ShippingMethodsForOrderPopup.vue?vue&type=style&index=0&id=778f543e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778f543e",
  null
  
)

export default component.exports